import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function FetchAllProjectsListService(token) {
    return axios.post(`${CURRENT_API_URL}/projectsDashboard/fetchAllProjectsList`,'',{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        // notify.NotifySuccess("Project list fetched successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching project list, please try again later.");
        return false;
    });
}

export default FetchAllProjectsListService;